import { Box, Link, Stack } from '@mui/material'
import { memo } from 'react'
import { faGift } from '@fortawesome/pro-light-svg-icons'

import homeBannerBg from '../../assets/images/home-bg.png'
import StakingIcon from './StakingIcon'
import Text from '../shared/text/Text'
import CustomButton from '../shared/buttons/CustomButton'
import FaIcon from '../shared/faIcon/FaIcon'
import PerkIcon from './PerkIcon'
import DefaultText from '../shared/text/DefaultText'
import { VIP_CLUB_URL } from '../../constants/app'
import BaseCard from '../shared/baseCard/BaseCard'

const StakingBanner = ({ t }) => {
  return (
    <BaseCard sx={{ p: 0 }}>
      <Stack
        spacing={2}
        direction={{ xs: 'column', md: 'row' }}
        sx={[
          (theme) => ({
            alignItems: 'center',
            py: { sm: 1, md: 2.5 },
            px: { sm: 2, md: 5 },
            background: [
              `linear-gradient(to right, rgba(33, 33, 33, 0.75) 0%, ${theme.palette.grey[900]} 75%)`,
              `url(${homeBannerBg})`
            ].join(', '),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          })
        ]}
      >
        <StakingIcon />
        <Box flexGrow={1} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Text
            variant='h2'
            sx={{ whiteSpace: 'pre-line', mb: 1, fontWeight: 700 }}
            label={t('staking.continue-staking')}
          />
          <DefaultText
            label={t('staking.continue-staking-desc')}
            sx={{ fontSize: 18, mb: 2 }}
          />
          <Text
            sx={{ fontSize: 18, mb: 2, fontWeight: 700 }}
            label={t('staking.rewards-such-as-entertainment')}
          />
          <Stack
            spacing={2}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              width: 1,
              justifyContent: 'space-between',
              alignItems: { xs: 'center', sm: 'flex-start' },
              pb: { xs: 3, sm: 0 }
            }}
          >
            <Stack
              spacing={2}
              direction='row'
              sx={{
                alignItems: { xs: 'center', sm: 'flex-start' }
              }}
            >
              {['netflix', 'spotify', 'gaming'].map((id) => (
                <PerkIcon
                  key={id}
                  src={`/assets/perks/${id}.jpg`}
                  size={56}
                  variant='rounded'
                />
              ))}
            </Stack>
            <CustomButton
              startIcon={<FaIcon icon={faGift} />}
              label={t('staking.stake')}
              component={Link}
              href={`${VIP_CLUB_URL}/staking`}
              target='_blank'
              color='yellow'
            />
          </Stack>
        </Box>
      </Stack>
    </BaseCard>
  )
}

export default memo(StakingBanner)
